import React, {Component} from "react";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleButton from "../../../../../modules/commons/SimpleButton";

class FakturJualDetailHeader extends Component {
    setValue = (name, value) => {
        this.props.onSetState ((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [name]: value
            }
        }))
    }

    checkDisabledButton = () => {
        if(this.props.tab === 'NOS'){
            return !this.props.state.isEditable || (!this.props.isDraft && this.props.selectedData)
        }
        return this.props.state.isEditable
    }
    
    render() {
        let {tab} = this.props;
        
        return (
            <div
                className="grid grid-2x grid-mobile-none gap-15px"
                style={{alignItems: "center"}}
            >
                <div id="grid-1">
                    <SimpleDDL
                        id="select_options_cabang"
                        box="search"
                        name="kodeCabang"
                        label="Cabang"
                        placeholder="Cabang hak akses"
                        mandatory
                        errorMessage={this.props.errors?.kodeCabang}
                        isClearable
                        options={this.props.cabangOptions}
                        value={this.props.data.kodeCabang}
                        readOnly={!this.props.state.isEditable}
                        onChange={(value, {name}) => this.setValue(name, value)}
                    />
                    <SimpleInput
                        id="input_text_no_faktur_jual"
                        name="id"
                        label={tab==="DGI"?"No. Faktur Jual DGI":"No. Faktur Jual"}
                        readOnly
                        value={this.props.data.nomorFakturJual}
                    />
                    <SimpleDate
                        id="select_date_tanggal_faktur_jual"
                        label="Tanggal Faktur Jual"
                        name="orderDate"
                        disabled
                        date={this.props.data.tanggalFakturJual}
                    />
                </div>
                <div id="grid-2">
                    <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                        <SimpleInput
                            id="input_text_no_indent"
                            name="indentNo"
                            label="No. Indent"
                            containerclassname="width width-full"
                            readOnly
                            value={this.props.data.indentNo}
                        />
                        <SimpleButton
                            disabled={this.checkDisabledButton()}
                            category="action_button"
                            icon={<i className="fa fa-search" style={{fontSize: 20}}/>}
                            onClick={() => this.props.onInputDataVisibility("Indent")}
                        />
                        <SimpleButton
                            disabled={this.checkDisabledButton()}
                            category="action_button"
                            icon={<span style={{fontSize: "16px", fontWeight: "bold"}}>X</span>}
                            onClick={() => this.setValue("indentNo", null)}
                        />
                    </div>
                    <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                        <SimpleInput
                            id="input_text_no_prospect"
                            name="prospectNo"
                            label="No. Prospect"
                            containerclassname="width width-full"
                            readOnly
                            value={this.props.data.prospectNo}
                        />
                        <SimpleButton
                            disabled={this.checkDisabledButton()}
                            category="action_button"
                            icon={<i className="fa fa-search" style={{fontSize: 20}}/>}
                            onClick={() => this.props.onInputDataVisibility("Prospek")}
                        />
                        <SimpleButton
                            disabled={this.checkDisabledButton()}
                            category="action_button"
                            icon={<span style={{fontSize: "16px", fontWeight: "bold"}}>X</span>}
                            onClick={() => this.setValue("prospectNo", null)}
                        />
                    </div>
                    <SimpleInput
                        id="input_text_jenis_prospect"
                        name="jenisProspect"
                        label="Jenis Prospect"
                        readOnly
                        value={this.props.data.jenisProspect}
                        onChange={(value, {name}) => this.setValue(name, value)}
                    />
                </div>
            </div>
        )
    }
}

export default FakturJualDetailHeader;